import logoFullSrc from "../assets/clawease-logo-pure-vector.svg";
import logoWhiteWordmarkSrc from "../assets/clawease-logo-white-wordmark.svg";

type BrandLogoProps = {
  variant?: "dark" | "light" | "inverse";
  size?: "compact" | "nav" | "footer";
  className?: string;
};

const sizeClasses = {
  compact: "h-8 w-auto",
  nav: "h-7 w-auto sm:h-8",
  footer: "h-10 w-auto",
};

export function BrandLogo({ variant = "dark", size = "nav", className = "" }: BrandLogoProps) {
  const lightSurfaceClass = size === "compact" ? "rounded-[10px] bg-white px-2.5 py-1.5" : "rounded-[12px] bg-white px-3 py-2";

  return (
    <span
      aria-label="ClawEase"
      className={`inline-flex shrink-0 items-center ${variant === "light" ? lightSurfaceClass : ""} ${className}`}
    >
      <img src={variant === "inverse" ? logoWhiteWordmarkSrc : logoFullSrc} alt="" aria-hidden="true" className={sizeClasses[size]} />
    </span>
  );
}
